import { LOCALE_CODE } from '@pkg/config/languages/localeCodes';

export default defineI18nConfig(() => ({
  // Other config options found in nuxt module config: ~/config/nuxt/modules/i18n.ts
  legacy: false,
  locale: LOCALE_CODE.EN_GB,
}));
